import { Controller } from "@hotwired/stimulus"

const PRIORITY_ORDER = { urgent: 0, normal: 1, optional: 2 }

export default class extends Controller {
  static targets = ["block", "toggleButton"]

  connect() {
    this.sorted = false
  }

  toggle() {
    this.sorted = !this.sorted
    const blocks = [...this.blockTargets]

    if (this.sorted) {
      blocks.sort((a, b) => {
        return (PRIORITY_ORDER[a.dataset.priority] ?? 1) - (PRIORITY_ORDER[b.dataset.priority] ?? 1)
      })
      this.toggleButtonTarget.classList.add("bg-pale", "font-extrabold")
    } else {
      blocks.sort((a, b) => {
        return parseInt(a.dataset.position) - parseInt(b.dataset.position)
      })
      this.toggleButtonTarget.classList.remove("bg-pale", "font-extrabold")
    }

    const parent = blocks[0]?.parentElement
    if (parent) {
      blocks.forEach((block) => parent.appendChild(block))
    }
  }
}
